import { render, staticRenderFns } from "./vipimg.vue?vue&type=template&id=5a179eca&scoped=true"
import script from "./vipimg.vue?vue&type=script&lang=js"
export * from "./vipimg.vue?vue&type=script&lang=js"
import style0 from "./vipimg.vue?vue&type=style&index=0&id=5a179eca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a179eca",
  null
  
)

export default component.exports